export default {
    prefixUrl: '/api',
    storageKey: 'o0iCXAaXy99uOiD4hX9EGb7Q',
    cartKey: 'MUOo0iCXAaXy99uOiD4hX9EGb7Q',
    defaultLanguage: 'en',
    packetaKey: '2b11f9d3d0b27425',
    apiKey: 'TTlMNERDSFFHRVA3OVZQVEJaWEYyMUlSRUE4NUJCTUI6bXVv',
};
